var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: _vm._f("twMerge")(['w-5 h-5 text-gray-500', _vm.className]),
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    }
  }, [_c('rect', {
    attrs: {
      "x": "2.5",
      "y": "14",
      "width": "2.75",
      "height": "7.5",
      "rx": "1",
      "fill": _vm.color
    }
  }), _c('rect', {
    attrs: {
      "x": "7",
      "y": "11",
      "width": "2.75",
      "height": "10.5",
      "rx": "1",
      "fill": _vm.color
    }
  }), _c('path', {
    attrs: {
      "d": "M3 10.5 8.5 5.5l3 2.5L18.5 2.5",
      "stroke": _vm.color,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.75 2.5h3.75v3.75",
      "stroke": _vm.color,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('circle', {
    attrs: {
      "cx": "17",
      "cy": "16.5",
      "r": "5.5",
      "fill": _vm.color
    }
  }), _c('path', {
    attrs: {
      "d": "M18.6 14.6c-.3-.5-.9-.8-1.6-.8-.9 0-1.6.5-1.6 1.2 0 1.6 3.3.9 3.3 2.6 0 .7-.7 1.3-1.7 1.3-.7 0-1.4-.3-1.7-.9M17 13v1M17 19v1",
      "stroke": "white",
      "stroke-width": "1.2",
      "stroke-linecap": "round"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }